var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7276 6.44418L18.4874 9.99287C18.7274 10.4869 19.3673 10.9607 19.9073 11.0514L23.0969 11.5858C25.1367 11.9285 25.6167 13.4206 24.1468 14.8925L21.6671 17.3927C21.2471 17.8161 21.0172 18.6327 21.1471 19.2175L21.8571 22.3125C22.417 24.7623 21.1272 25.71 18.9774 24.4296L15.9877 22.6452C15.4478 22.3226 14.5579 22.3226 14.0079 22.6452L11.0183 24.4296C8.8785 25.71 7.57865 24.7522 8.13859 22.3125L8.84851 19.2175C8.97849 18.6327 8.74852 17.8161 8.32856 17.3927L5.84884 14.8925C4.389 13.4206 4.85895 11.9285 6.89872 11.5858L10.0884 11.0514C10.6183 10.9607 11.2582 10.4869 11.4982 9.99287L13.258 6.44418C14.2179 4.51861 15.7777 4.51861 16.7276 6.44418Z",
    stroke: "#38F2E4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/StarBlue.2a2f2b606debe314e2d0590d469c4450.svg";
export { ForwardRef as ReactComponent };